const isNaN = (x) => Number.isNaN(x);
export default isNaN;
